import { apiHolder as api, apis, } from 'api';
import moment from 'moment';
import { folderCanSortByTop, orderCanSortByTop } from './folder';
import { getMailListByIdFromStore, isMainAccount, folderIdIsContact, folderIdIsAllFolder, parseFidFromAllFid, folderIdIsAllTopFolder, isLockTag, getQueryParamsByVirtualTag, } from '@web-mail/util';
import lodash from 'lodash';
import { FLOLDER, MAIL_STORE_REDUX_STATE, MAIL_LIST_INIT_RANGE_COUNT, MAIL_LIST_MORE_RANGE_COUNT } from '../../common/constant';
import { getCardHeight } from '@web-mail/utils/mailCardUtil';
import { sliceStateCheck } from '@web-mail/utils/slice';
import { getMailOrderDescRequestParam, getMailOrderRequestParam, needTimeRangeByMailOrderType } from './utils';
import { getIn18Text } from 'api';
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const systemApi = api.api.getSystemApi();
export const idIsTreadMail = (id) => {
    if (id) {
        try {
            const mailIdReg = /\d+/;
            const [realId] = id.split('--') || [''];
            const [res] = mailIdReg.exec(realId) || [null];
            if (res && res.length === realId.length) {
                return true;
            }
        }
        catch (_a) {
            return false;
        }
        return false;
    }
    return false;
};
export const mailConfigStateIsMerge = () => mailConfApi.getMailMergeSettings() == 'true';
export const mailLogicStateIsMerge = (fid, accountId, isSearching) => mailConfigStateIsMerge() &&
    !folderIdIsAllFolder(fid) &&
    (fid === FLOLDER.DEFAULT || fid >= 20 || fid == FLOLDER.TAG || fid == FLOLDER.REDFLAG || fid == FLOLDER.UNREAD) &&
    !isSearching &&
    (accountId == '' || accountId == null || isMainAccount(accountId));
export const isMerge = (selectedKeys, accountId, isSearching) => mailLogicStateIsMerge(selectedKeys, accountId, isSearching);
export const getIsUseRealList = (state) => {
    if (!process.env.BUILD_ISLINGXI)
        return false;
    const isUseRealList = state.useRealList;
    const isSeaching = !!state.mailSearching;
    const selectrKeys = state.selectedKeys;
    const isTaskFolder = selectrKeys && selectrKeys.id === FLOLDER.TASK;
    return isUseRealList && !isSeaching && !isTaskFolder && !folderIdIsAllFolder(selectrKeys === null || selectrKeys === void 0 ? void 0 : selectrKeys.id);
};
export const getMailListReqParams = (state, startIndex, isCorpMail = false, noContactRace) => {
    const { selectedKeys, mailTagFolderActiveKey, mailListStateTab, mailSearchStateMap, orderDateRange, mailEntities, mailDataList, useRealList, realListCurrentPageSize, realListCurrentPage, } = state;
    let fid = selectedKeys ? selectedKeys.id : 1;
    const mergeUseRealList = useRealList && !folderIdIsAllFolder(fid);
    const idIsContact = folderIdIsContact(fid);
    const setting = mailLogicStateIsMerge(selectedKeys.id, selectedKeys.accountId, Object.keys(mailSearchStateMap).length > 0);
    let count = mergeUseRealList ? realListCurrentPageSize : MAIL_LIST_MORE_RANGE_COUNT;
    if (!mergeUseRealList && (startIndex === 0 || selectedKeys.id === FLOLDER.TASK)) {
        count = MAIL_LIST_INIT_RANGE_COUNT;
    }
    const param = {
        index: startIndex,
        id: folderIdIsAllFolder(fid) ? parseFidFromAllFid(fid) : fid,
        count,
        returnModel: true,
        returnTag: true,
        noContactRace,
    };
    if (folderIdIsAllTopFolder(selectedKeys.id)) {
        const subEmails = Object.values(state.mailTreeStateMap)
            .filter(mailTreeState => !mailTreeState.expired)
            .map(mailTreeState => { var _a; return ((_a = systemApi.getCurrentUser(mailTreeState.accountId)) === null || _a === void 0 ? void 0 : _a.id) || mailTreeState.accountId; })
            .filter(Boolean);
        param.subEmails = subEmails;
    }
    if (mergeUseRealList) {
        param.isRealList = true;
    }
    if ((param === null || param === void 0 ? void 0 : param.id) && [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW].includes(+param.id)) {
        param.startId = mailDataList[mailDataList.length - 1];
        param.isRealList = false;
    }
    if (selectedKeys && selectedKeys.id === FLOLDER.TAG && !isLockTag((mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key) || '')) {
        param.id = undefined;
        fid = undefined;
        if (mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key) {
            param.tag = [mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key];
        }
    }
    if (selectedKeys && selectedKeys.id === FLOLDER.TAG && (mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key) && isLockTag((mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key) || '')) {
        param.filter = {
            systemLabel: getQueryParamsByVirtualTag(mailTagFolderActiveKey === null || mailTagFolderActiveKey === void 0 ? void 0 : mailTagFolderActiveKey.key),
        };
    }
    if (mailListStateTab === 'UNREAD') {
        param.filter = {
            flags: { read: false },
        };
    }
    else if (mailListStateTab === 'REDFLAG') {
        param.filter = { label0: 1 };
    }
    else if (mailListStateTab === 'ATTACHMENT') {
        param.filter = {
            flags: { attached: true },
        };
    }
    else if (mailListStateTab === 'MY_CUSTOMER') {
        param.filter = {
            flags: { customerMail: true },
        };
        param.noSync = true;
    }
    else if (mailListStateTab === 'RECEIVER_UNREAD' || mailListStateTab === 'RECEIVER_READ') {
        param.filter = {
            flags: { receiverRead: mailListStateTab === 'RECEIVER_READ' ? true : false },
        };
        param.noSync = true;
    }
    else if (folderCanSortByTop(fid, isCorpMail) && orderCanSortByTop(mailListStateTab)) {
        param.topFlag = 'top';
    }
    if (mailListStateTab.startsWith('ORDER_BY_')) {
        param.order = getMailOrderRequestParam(mailListStateTab);
        param.desc = getMailOrderDescRequestParam(mailListStateTab);
        if (needTimeRangeByMailOrderType(mailListStateTab) && (orderDateRange === null || orderDateRange === void 0 ? void 0 : orderDateRange.startDate) && (orderDateRange === null || orderDateRange === void 0 ? void 0 : orderDateRange.endDate)) {
            param.filter = {
                sentDate: [moment(orderDateRange === null || orderDateRange === void 0 ? void 0 : orderDateRange.startDate).format('YYYY-MM-DD'), moment(orderDateRange === null || orderDateRange === void 0 ? void 0 : orderDateRange.endDate).format('YYYY-MM-DD')],
            };
        }
    }
    if (selectedKeys.id === FLOLDER.TASK) {
        if (mailListStateTab === 'ALL') {
            param.filter = {
                taskTab: 0,
            };
        }
        else if (mailListStateTab === 'ON') {
            param.filter = {
                taskTab: 1,
            };
        }
    }
    if (selectedKeys.id === FLOLDER.DEFER) {
        if (mailListStateTab === 'DEFER') {
            param.filter = {
                defer: `:${moment().format('YYYYMMDD')}`,
            };
        }
    }
    if (setting) {
        param.checkType = 'checkThread';
    }
    if (idIsContact || selectedKeys.id === FLOLDER.STAR) {
        param.checkType = 'checkStarMail';
        if (mailListStateTab === 'SENT') {
            param.attrQueryFilter = {
                type: 'send',
            };
        }
        if (mailListStateTab === 'RECEIVED') {
            param.attrQueryFilter = {
                type: 'receive',
            };
        }
    }
    return param;
};
export const getFilterCondParams = (state) => {
    var _a;
    const filterCond = [];
    const { selectedSearchKeys, mailSearchAccount } = state;
    const accountKeys = selectedSearchKeys[mailSearchAccount];
    for (const key in accountKeys) {
        if (key !== 'folder' && ((_a = accountKeys[key]) === null || _a === void 0 ? void 0 : _a.operand) !== 'all') {
            filterCond.push(accountKeys[key]);
        }
    }
    return filterCond;
};
export const getAdvanceSearchReqParams = (state, filterCond, startIndex) => {
    var _a;
    const { selectedSearchKeys, searchListStateTab, advanceSearchFromValues: values, mailSearchAccount, useRealList, realListCurrentPageSize } = state;
    const fids = values.fids && values.fids !== '_ALL_FOLDER_' ? [values.fids] : [];
    const tag = values.tag ? [values.tag] : [];
    const flags = {
        attached: values.attach === 0 ? undefined : values.attach === 1,
        read: searchListStateTab == 'UNREAD' ? false : undefined,
    };
    if ((_a = selectedSearchKeys[mailSearchAccount]) === null || _a === void 0 ? void 0 : _a.folder) {
        fids.push(+selectedSearchKeys[mailSearchAccount].folder);
    }
    const valueCondition = {
        from: values.from,
        to: values.to,
        memo: values.memo,
        subject: values.subject,
        label0: values.redFlag || searchListStateTab == 'REDFLAG' ? 1 : undefined,
        operator: values.operator,
        flags,
        sentDate: [moment.isMoment(values.start) ? values.start.format('YYYY-MM-DD') : undefined, moment.isMoment(values.end) ? values.end.format('YYYY-MM-DD') : undefined],
    };
    if (Array.isArray(filterCond)) {
        filterCond.forEach(cond => {
            if (cond.field === 'from' && cond.operand) {
                valueCondition.from = cond.operand;
            }
        });
    }
    return {
        pattern: values.content,
        start: startIndex,
        limit: useRealList ? realListCurrentPageSize : 20,
        windowSize: useRealList ? realListCurrentPageSize : undefined,
        summaryWindowSize: useRealList ? realListCurrentPageSize : undefined,
        fids: fids.length > 0 ? fids : undefined,
        tag,
        conditions: [valueCondition],
        filterCond,
        subject: values.subject,
    };
};
export const getAdvanceSearchReqParams_sd = (state, startIndex, sliceId) => {
    if (sliceStateCheck(state, sliceId, 'subordinate')) {
        const { selectedFolder, advanceSearchFromValues: values } = state.subordinate[sliceId];
        const { ids = [] } = selectedFolder || {};
        const valueCondition = {
            from: values.from,
            to: values.to,
            subject: values.subject,
            label0: ids.length === 1 && ids[0] === FLOLDER.REDFLAG ? 1 : undefined,
            operator: values.operator,
        };
        return {
            pattern: values.content + '',
            start: startIndex,
            limit: 20,
            fids: ids.length === 1 && ids[0] > 0 ? ids : undefined,
            tag: [],
            conditions: [valueCondition],
        };
    }
    else {
        console.error('getAdvanceSearchReqParams_sd sliceStateCheck error');
        return null;
    }
};
export const getSearchListReqParams = (state, startIndex) => {
    var _a, _b;
    const { selectedSearchKeys, mailSearchType, searchListStateTab, mailSearchAccount, mailSearchFolderIds, useRealList, realListCurrentPageSize } = state;
    let fid = FLOLDER.SEARCH_ALL_RESULT;
    const ids = [...mailSearchFolderIds];
    if ((_a = selectedSearchKeys[mailSearchAccount]) === null || _a === void 0 ? void 0 : _a.folder) {
        fid = +((_b = selectedSearchKeys[mailSearchAccount]) === null || _b === void 0 ? void 0 : _b.folder);
    }
    const param = {
        index: startIndex,
        count: !useRealList ? 20 : realListCurrentPageSize,
        returnModel: true,
        returnTag: true,
        searchType: mailSearchType,
    };
    if (fid !== FLOLDER.SEARCH_ALL_RESULT) {
        param.id = fid;
        ids.unshift(fid);
    }
    param.ids = ids;
    if (searchListStateTab === 'UNREAD') {
        param.status = 'unread';
    }
    else if (searchListStateTab === 'REDFLAG') {
        param.status = 'redFlag';
    }
    return param;
};
export const getSearchListReqParams_sd = (state, startIndex = 0, sliceId) => {
    if (sliceStateCheck(state, sliceId, 'subordinate')) {
        const { mailSearchType, selectedFolder } = state.subordinate[sliceId];
        const { ids = [], subordinateId = '', relationEmailList = [] } = selectedFolder || {};
        const param = {
            index: startIndex,
            count: 20,
            returnModel: true,
            returnTag: true,
            searchType: mailSearchType,
            subordinateId,
        };
        if (ids.length === 1) {
            param.id = +ids[0];
        }
        if (relationEmailList && relationEmailList.length) {
            param.subEmails = relationEmailList.map(acc => acc.email);
        }
        if (param.id === FLOLDER.REDFLAG) {
            param.status = 'redFlag';
        }
        return param;
    }
    else {
        console.error('getSearchListReqParams_sd sliceStateCheck error');
        return null;
    }
};
export const getSearchListReqParams_sd_more = (state, startIndex = 0, sliceId) => {
    if (sliceStateCheck(state, sliceId, 'subordinate')) {
        const { subordinateList, mailSearchKey, mailSearchType, more_searchingRequestId, searchList: searchListOld, mailSearchState, mailSearchState_old, more_advanceSearchFromValues, } = state.subordinate[sliceId];
        const searchList = getMailListByIdFromStore(searchListOld, state.mailEntities);
        const searchId = more_searchingRequestId || undefined;
        const lastOrderTime = searchList && searchList.length ? searchList[searchList.length - 1].entry.sendTime : '';
        const subEmails2Account = {};
        const subEmails = new Set();
        subordinateList
            .filter(subordinate => subordinate.id !== 'allSubordinate')
            .forEach(subordinate => {
            if (subordinate.email && subordinate.id) {
                subEmails.add(subordinate.email);
                subEmails2Account[subordinate.email] = subordinate.id;
            }
        });
        const searchState = mailSearchState === 'more_AI' ? mailSearchState_old : mailSearchState;
        if (searchState === 'more_advanced') {
            return Object.assign(Object.assign({}, more_advanceSearchFromValues), { limit: 50, lastOrderTime: startIndex === 0 ? undefined : lastOrderTime, searchId });
        }
        else {
            const param = {
                operator: 'or',
                highlight: mailSearchKey,
                subEmails2Account,
                limit: 50,
                lastOrderTime: startIndex === 0 ? undefined : lastOrderTime,
                searchId,
                searchType: mailSearchType,
            };
            if (mailSearchType === 'all' || mailSearchType === 'title') {
                param.subj = { operator: 'contains', field: 'subj', operand: mailSearchKey };
            }
            if (mailSearchType === 'all' || mailSearchType === 'sender') {
                param.from = { operator: 'contains', field: 'from', operand: mailSearchKey };
            }
            if (mailSearchType === 'all' || mailSearchType === 'receiver') {
                param.to = { operator: 'contains', field: 'to', operand: mailSearchKey };
            }
            if (mailSearchType === 'all' || mailSearchType === 'attachment') {
                param.aname = { operator: 'contains', field: 'aname', operand: mailSearchKey };
            }
            if (mailSearchType === 'all') {
                param.cont = { operator: 'contains', field: 'cont', operand: mailSearchKey };
            }
            return param;
        }
    }
    else {
        console.error('getSearchListReqParams_sd sliceStateCheck error');
        return {};
    }
};
export const asyncMailList = (argMailList, sliceList) => {
    var _a, _b, _c;
    if (!argMailList || !sliceList)
        return [];
    const min = argMailList.length - sliceList.length;
    if (argMailList.length === 0 || sliceList.length === 0) {
        return [...argMailList, ...sliceList];
    }
    let offset = 0;
    for (let i = argMailList.length - 1; i >= min; i--) {
        const curMail = argMailList[i];
        if (((_a = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _a === void 0 ? void 0 : _a.id) === ((_c = (_b = sliceList[0]) === null || _b === void 0 ? void 0 : _b.entry) === null || _c === void 0 ? void 0 : _c.id)) {
            offset += 1;
            break;
        }
        offset += 1;
    }
    if (offset === sliceList.length) {
        return [...argMailList, ...sliceList];
    }
    return [...argMailList, ...sliceList.slice(offset)];
};
export const conactMailList = (mailList = [], lastMailList = []) => {
    var _a, _b, _c, _d, _e;
    let list = [...mailList];
    const listMap = {};
    mailList.forEach((item, index) => {
        const { id } = item.entry;
        if (id) {
            listMap[id] = [index];
        }
    });
    if (mailList && mailList.length) {
        for (let i = 0; i < lastMailList.length; i++) {
            const id = (_b = (_a = lastMailList[i]) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.id;
            if (!listMap[id]) {
                const index = i - 1;
                if (index >= 0) {
                    const preId = (_d = (_c = lastMailList[index]) === null || _c === void 0 ? void 0 : _c.entry) === null || _d === void 0 ? void 0 : _d.id;
                    if (preId && listMap[preId]) {
                        const [preIndex] = listMap[preId];
                        if (preIndex) {
                            list = [...mailList.slice(0, preIndex), ...(_e = lastMailList.slice(index)) === null || _e === void 0 ? void 0 : _e.filter(item => !listMap[item.entry.id])];
                            return list;
                        }
                    }
                }
            }
        }
    }
    return [...mailList, ...lastMailList.filter(item => !listMap[item.entry.id])];
};
export const getMailListRowHeight = getCardHeight;
export const getTopMailSumHeight = (mailDataList) => {
    let offset = 0;
    mailDataList.forEach(mail => {
        if (mail.entry.top) {
            offset += getMailListRowHeight(mail);
        }
    });
    return offset;
};
export const getNewMailsFromList = (networkList, lastUpdateTime) => {
    if (networkList && networkList.length) {
        const newMailList = networkList.filter(item => {
            const rcTime = item.entry.receiveTime;
            if (rcTime) {
                const rsTs = moment(rcTime).valueOf();
                if (rsTs) {
                    return rsTs > lastUpdateTime;
                }
            }
            return false;
        });
        if (!newMailList || !newMailList.length) {
            return null;
        }
        let sumNewMailHeight = 0;
        newMailList.forEach(item => (sumNewMailHeight += getMailListRowHeight(item)));
        return {
            sumHeight: sumNewMailHeight,
            sumNewMail: newMailList.length,
            insertPosi: newMailList.length,
        };
    }
    return null;
};
export const getMailDiffId = (mail) => {
    var _a, _b, _c;
    if (mail === null || mail === void 0 ? void 0 : mail.isThread) {
        if (((_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id) && mail.entry.id.includes('--')) {
            const realId = mail.entry.id.split('--')[0];
            return realId;
        }
        else {
            return (_b = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _b === void 0 ? void 0 : _b.id;
        }
    }
    else {
        return (_c = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _c === void 0 ? void 0 : _c.id;
    }
};
export const mailListDiff = (newList, oldList) => {
    if (newList && newList.length && oldList && oldList.length) {
        let aim;
        let posi = -1;
        let offset = 1;
        do {
            if (offset > newList.length) {
                break;
            }
            aim = newList[newList.length - offset];
            posi = oldList.findIndex(item => getMailDiffId(item) === getMailDiffId(aim));
            offset += 1;
        } while (posi < 0);
        if (posi && posi >= 0) {
            let sumNewMailHeight = 0;
            const oldMailIdList = oldList.map(item => getMailDiffId(item));
            const newMailList = newList.slice(0, posi).filter(item => !oldMailIdList.includes(getMailDiffId(item)));
            if (newMailList.length == 0) {
                return null;
            }
            newMailList.forEach(item => (sumNewMailHeight += getMailListRowHeight(item)));
            return {
                sumHeight: sumNewMailHeight,
                sumNewMail: newMailList.length,
                insertPosi: posi,
            };
        }
    }
    return null;
};
export const getCanActiveMailId = (mailList, selectedIds, activeId) => {
    const mailId2Index = {};
    const index2MailId = {};
    const selectedMap = {};
    selectedIds.forEach(item => {
        selectedMap[item] = true;
    });
    mailList.forEach((mail, index) => {
        mailId2Index[mail.entry.id] = index;
        index2MailId[index] = mail.entry.id;
    });
    let resMailId = null;
    let resMailIndex = null;
    if (!selectedIds.includes(activeId))
        return activeId;
    for (let i = mailId2Index[activeId]; i < mailList.length; i++) {
        const curMailId = index2MailId[i];
        if (!selectedMap[curMailId]) {
            resMailId = curMailId;
            resMailIndex = i;
            break;
        }
    }
    if (resMailId == null && resMailIndex == null) {
        for (let i = mailId2Index[activeId]; i >= 0; i--) {
            const curMailId = index2MailId[i];
            if (!selectedMap[curMailId]) {
                resMailId = curMailId;
                resMailIndex = i;
                break;
            }
        }
    }
    return resMailId;
};
export const getRealCountFromAvtiveMails = (params) => {
    const { isSearching, mailDataList, selectedKeysId, selectedKeysAccountId } = params;
    let realMailSum = mailDataList.length;
    if (isMerge(selectedKeysId, selectedKeysAccountId, isSearching)) {
        realMailSum = 0;
        mailDataList.forEach(item => {
            var _a;
            realMailSum += ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.threadMessageCount) || 0;
        });
    }
    return realMailSum;
};
export const getTopCountFromMailList = (list) => {
    let topCount = 0;
    list.forEach(item => {
        if (item.entry.top) {
            topCount += 1;
        }
    });
    return topCount;
};
export const getCurMailList = (state) => {
    const { searchList, mailDataList } = state;
    const isSearching = getIsSearchingMailByState(state);
    return getMailListByIdFromStore(isSearching ? searchList : mailDataList, state.mailEntities);
};
export const mailCanDoTop = (state, id) => {
    const { selectedKeys, mailListStateTab } = state;
    return !!(folderCanSortByTop(selectedKeys.id) && mailListStateTab === 'ALL');
};
export const isSystemTag = (tagName) => tagName != '__delivery__' && tagName != '__deliveryrecord__' && tagName.startsWith('%') && tagName.endsWith('%');
export const filterSysTagInMail = (mail) => (Object.assign(Object.assign({}, mail), { tags: mail.tags ? mail.tags.filter(tag => !isSystemTag(tag)) : undefined }));
export const filterSysTagInMailList = (list) => list.map(item => {
    if (item.tags) {
        return Object.assign(Object.assign({}, item), { tags: item.tags.filter(tag => !isSystemTag(tag)) });
    }
    return item;
});
export const getUniqMailList = (list) => {
    if (list && list.length) {
        const map = new Map();
        const res = list.filter(item => {
            const { id } = item.entry;
            if (map.has(id)) {
                return false;
            }
            map.set(item.entry.id, true);
            return true;
        });
        return res;
    }
    return list;
};
export const formateMailList = (list) => {
    try {
        return filterSysTagInMailList(getUniqMailList(list));
    }
    catch (e) {
        console.error('util-formateMailList', e);
    }
    return list;
};
export const folderOperErrCode2Msg = (errCode) => {
    let res = getIn18Text('YIDONGSHIBAI');
    return res;
};
export const getMailsByIdsHelper = (models, ids) => {
    if (!ids) {
        return [];
    }
    const result = [];
    ids.forEach(id => {
        const model = models[id];
        if (model) {
            result.push(model);
        }
    });
    return filterSysTagInMailList(result);
};
export const isSearchingHelper = (searchState) => searchState !== '';
const mergeCustomizer = (objValue, srcValue) => {
    if (srcValue === undefined) {
        return objValue;
    }
    else {
        return srcValue;
    }
};
export const updateMailStore = (state, mailList, exclude) => {
    if (state && state[MAIL_STORE_REDUX_STATE] && mailList && mailList.length) {
        mailList.forEach(mail => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20;
            const mailId = (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id;
            if (mailId) {
                const curMail = state[MAIL_STORE_REDUX_STATE][mailId];
                try {
                    if (mail && curMail && (mail === null || mail === void 0 ? void 0 : mail.mailFrom) !== (curMail === null || curMail === void 0 ? void 0 : curMail.mailFrom) && (mail === null || mail === void 0 ? void 0 : mail.isTpMail) != (curMail === null || curMail === void 0 ? void 0 : curMail.isTpMail)) {
                        const restMail = (mail === null || mail === void 0 ? void 0 : mail.isTpMail) ? curMail : mail;
                        if (restMail) {
                            state[MAIL_STORE_REDUX_STATE][mailId] = restMail;
                        }
                        return;
                    }
                }
                catch (e) {
                    console.error('mailid 碰撞error', e);
                }
                if (curMail) {
                    try {
                        const content = ((_c = (_b = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.content) ? (_d = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _d === void 0 ? void 0 : _d.content : (_e = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _e === void 0 ? void 0 : _e.content;
                        let attachment = [];
                        let ecInfo = mail.entry.tr_org_ec_info || ((_f = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _f === void 0 ? void 0 : _f.tr_org_ec_info);
                        let ecId = mail.entry.tr_org_ec_id || ((_g = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _g === void 0 ? void 0 : _g.tr_org_ec_id);
                        if (mail.isDecrypted && !curMail.isDecrypted) {
                            attachment = ((_h = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _h === void 0 ? void 0 : _h.attachment) || [];
                        }
                        else if (!mail.isDecrypted && curMail.isDecrypted) {
                            attachment = ((_j = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _j === void 0 ? void 0 : _j.attachment) || [];
                        }
                        else {
                            if ((_l = (_k = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _k === void 0 ? void 0 : _k.attachment) === null || _l === void 0 ? void 0 : _l.length) {
                                if (mail.entry.attSource == 'content') {
                                    attachment = ((_m = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _m === void 0 ? void 0 : _m.attachment) || [];
                                }
                                else {
                                    attachment = ((_o = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _o === void 0 ? void 0 : _o.attachment) || [];
                                }
                            }
                            else {
                                attachment = ((_p = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _p === void 0 ? void 0 : _p.attachment) || [];
                            }
                        }
                        let mergeReceiver = [];
                        if ((mail === null || mail === void 0 ? void 0 : mail.receiver) && (curMail === null || curMail === void 0 ? void 0 : curMail.receiver)) {
                            mergeReceiver = ((_q = curMail === null || curMail === void 0 ? void 0 : curMail.receiver) === null || _q === void 0 ? void 0 : _q.length) > (mail === null || mail === void 0 ? void 0 : mail.receiver.length) ? curMail === null || curMail === void 0 ? void 0 : curMail.receiver : mail === null || mail === void 0 ? void 0 : mail.receiver;
                        }
                        else {
                            mergeReceiver = (mail === null || mail === void 0 ? void 0 : mail.receiver) ? mail === null || mail === void 0 ? void 0 : mail.receiver : curMail === null || curMail === void 0 ? void 0 : curMail.receiver;
                        }
                        const cloneSender = Object.assign(Object.assign({}, mail.sender), { contact: Object.assign(Object.assign({}, (_r = mail.sender) === null || _r === void 0 ? void 0 : _r.contact), { customerOrgModel: ((_t = (_s = mail.sender) === null || _s === void 0 ? void 0 : _s.contact) === null || _t === void 0 ? void 0 : _t.customerOrgModel) === undefined && ((_v = (_u = mail.sender) === null || _u === void 0 ? void 0 : _u.contactItem) === null || _v === void 0 ? void 0 : _v.type) === 'external'
                                    ? (_x = (_w = curMail.sender) === null || _w === void 0 ? void 0 : _w.contact) === null || _x === void 0 ? void 0 : _x.customerOrgModel
                                    : (_z = (_y = mail.sender) === null || _y === void 0 ? void 0 : _y.contact) === null || _z === void 0 ? void 0 : _z.customerOrgModel }) });
                        const langListMap = Object.assign({}, ((_0 = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _0 === void 0 ? void 0 : _0.langListMap) || {}, ((_1 = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _1 === void 0 ? void 0 : _1.langListMap) || {});
                        const langType = ((_2 = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _2 === void 0 ? void 0 : _2.langType) || ((_3 = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _3 === void 0 ? void 0 : _3.langType);
                        const resMail = Object.assign(Object.assign(Object.assign({}, curMail), mail), { receiver: mergeReceiver, sender: cloneSender, entry: Object.assign(Object.assign({}, lodash.mergeWith((curMail === null || curMail === void 0 ? void 0 : curMail.entry) || {}, (mail === null || mail === void 0 ? void 0 : mail.entry) || {}, mergeCustomizer)), { content, attachment: attachment, langListMap,
                                langType, memo: (_4 = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _4 === void 0 ? void 0 : _4.memo, tr_org_ec_info: ecInfo, tr_org_ec_id: ecId }) });
                        if (exclude && exclude.length) {
                            exclude.forEach(path => {
                                lodash.set(resMail, path, lodash.get(curMail, path));
                            });
                        }
                        if (resMail.tags && resMail.tags.length) {
                            resMail.tags = (_5 = resMail === null || resMail === void 0 ? void 0 : resMail.tags) === null || _5 === void 0 ? void 0 : _5.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
                        }
                        if (((_7 = (_6 = resMail.sender) === null || _6 === void 0 ? void 0 : _6.contact) === null || _7 === void 0 ? void 0 : _7.customerOrgModel) === undefined && ((_9 = (_8 = resMail.sender) === null || _8 === void 0 ? void 0 : _8.contactItem) === null || _9 === void 0 ? void 0 : _9.type) === 'external') {
                            resMail.sender.contact.customerOrgModel = ((_11 = (_10 = curMail.sender) === null || _10 === void 0 ? void 0 : _10.contact) === null || _11 === void 0 ? void 0 : _11.customerOrgModel) || undefined;
                        }
                        if (!!curMail.owner && !mail.owner) {
                            resMail.owner = curMail.owner;
                        }
                        if (!!curMail.mainAccount && !mail.mainAccount) {
                            resMail.mainAccount = curMail.mainAccount;
                        }
                        if (!!curMail.tpMailInfo || !!mail.tpMailInfo) {
                            resMail.tpMailInfo = Object.assign(Object.assign({}, curMail.tpMailInfo), mail.tpMailInfo);
                            resMail.tpMailInfo.subordinateFromAI = !!((_12 = mail === null || mail === void 0 ? void 0 : mail.tpMailInfo) === null || _12 === void 0 ? void 0 : _12.subordinateFromAI);
                        }
                        try {
                            if (process.env.BUILD_ISEDM && curMail.entry.systemLabel) {
                                if (((_14 = (_13 = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _13 === void 0 ? void 0 : _13.systemLabel) === null || _14 === void 0 ? void 0 : _14.includes(3)) && (!resMail.entry.systemLabel || !((_15 = resMail.entry.systemLabel) === null || _15 === void 0 ? void 0 : _15.includes(3)))) {
                                    if (resMail.entry.systemLabel) {
                                        (_16 = resMail.entry.systemLabel) === null || _16 === void 0 ? void 0 : _16.unshift(3);
                                    }
                                    else {
                                        resMail.entry.systemLabel = [3];
                                    }
                                }
                                if (((_18 = (_17 = curMail === null || curMail === void 0 ? void 0 : curMail.entry) === null || _17 === void 0 ? void 0 : _17.systemLabel) === null || _18 === void 0 ? void 0 : _18.includes(4)) && (!resMail.entry.systemLabel || !((_19 = resMail.entry.systemLabel) === null || _19 === void 0 ? void 0 : _19.includes(4)))) {
                                    if (resMail.entry.systemLabel) {
                                        (_20 = resMail.entry.systemLabel) === null || _20 === void 0 ? void 0 : _20.unshift(4);
                                    }
                                    else {
                                        resMail.entry.systemLabel = [4];
                                    }
                                }
                            }
                        }
                        catch (e) {
                            console.log('updateMailEntities: filtertag error', e);
                        }
                        if (curMail.entry.isFollowUp !== undefined && mail.entry.isFollowUp === undefined) {
                            resMail.entry.isFollowUp = curMail.entry.isFollowUp;
                        }
                        state[MAIL_STORE_REDUX_STATE][mailId] = resMail;
                    }
                    catch (err) {
                        state[MAIL_STORE_REDUX_STATE][mailId] = mail;
                        console.error('[updateMailEntities merge err]:', err);
                    }
                }
                else {
                    state[MAIL_STORE_REDUX_STATE][mailId] = mail;
                }
            }
            else {
                console.warn('updateMailEntities: mailEntities写入数据有误', mail);
            }
        });
    }
};
export const updateMailStoreNoMerge = (state, mailList) => {
    if (state && state[MAIL_STORE_REDUX_STATE] && mailList && mailList.length) {
        mailList.forEach(mail => {
            var _a, _b;
            const mailId = (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id;
            if (mailId) {
                try {
                    if (mail.tags && mail.tags.length) {
                        mail.tags = (_b = mail === null || mail === void 0 ? void 0 : mail.tags) === null || _b === void 0 ? void 0 : _b.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
                    }
                }
                catch (e) {
                    console.warn('updateMailEntities: filtertag error', e);
                }
                state[MAIL_STORE_REDUX_STATE][mailId] = mail;
            }
            else {
                console.warn('updateMailEntities: mailEntities写入数据有误', mail);
            }
        });
    }
};
export const separateUpdateIdAndStore = (state, stateName, mailList, config) => {
    const { exclude, key, sliceId, type } = config || {};
    const targetState = state && sliceId && type ? state[type][sliceId] : state;
    if (state && targetState && mailList) {
        const newList = mailList.map(mail => { var _a; return (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id; });
        if (sliceId && type) {
            state[type][sliceId][stateName] = newList;
        }
        else {
            state[stateName] = newList;
        }
        if (exclude && exclude.length && key) {
            mailList.forEach(mail => {
                exclude.forEach(item => {
                    lodash.set(state.mailExcludeKeyMap, [key, mail.entry.id].join('.') + item, lodash.get(mail, item));
                });
            });
            updateMailStore(state, mailList, exclude);
        }
        else {
            updateMailStore(state, mailList);
        }
    }
};
export const getAccountByMailId = (state, mailId) => {
    const { mailEntities } = state;
    let id = Array.isArray(mailId) ? mailId[0] : mailId;
    if (mailEntities && mailId && mailEntities[id]) {
        const mail = mailEntities[id];
        return mail === null || mail === void 0 ? void 0 : mail._account;
    }
    return '';
};
export const getFolderByMailId = (state, mailId) => {
    const { mailEntities } = state;
    let id = Array.isArray(mailId) ? mailId[0] : mailId;
    if (mailEntities && mailId && mailEntities[id]) {
        const mail = mailEntities[id];
        return mail.entry.folder;
    }
    return null;
};
export const formatMailDataList = (inputList) => {
    const map = new Map();
    let list = inputList;
    try {
        list = list.filter(item => {
            const { id } = item.entry;
            if (map.has(id)) {
                return false;
            }
            map.set(item.entry.id, true);
            return true;
        });
        list = list.map(item => {
            if (item.tags) {
                item.tags = item.tags.filter(tag => !tag.startsWith('%') && !tag.endsWith('%'));
            }
            return item;
        });
    }
    catch (e) {
        console.warn(e);
    }
    return list;
};
export const getIsSearchingMailByState = (state, sliceId = '', key) => {
    if (sliceStateCheck(state, sliceId, key)) {
        if (key === 'subordinate') {
            return false;
        }
        return !!state.customer[sliceId].mailSearching;
    }
    return !!state.mailSearching;
};
